import EA from '../helpers/init';

export default EA.Methods.detectScroll = ($this) => {
    const handleScroll = () => {
        document.body.classList.toggle('scrolled', window.scrollY > 0);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
};
